import React from 'react'

import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ChangePassword from './pages/ChangePassword';
import ConfirmEmail from './pages/ConfirmEmail';
import Logout from './pages/Logout';
import Home from './pages/Home';

import VerifyPayment from "./pages/VerifyPayment";
import ViewSkills from "./pages/ViewSkills";
import Exhibition from './pages/website/Exhibition';
import Registration from './pages/website/Registration';
import RequisitionForm from './pages/website/RequisitionForm';

const UnProtectedView =()=> {
  return (
    <>
       
        <Routes>
        
        <Route  path="/" element={<Home /> } /> 
        
        <Route  path="/login" element={<Login /> } /> 
        
        <Route  path="/verify-payment" element={<VerifyPayment /> } /> 
        <Route  path="/view-skills" element={<ViewSkills /> } /> 
        <Route  path="/exhibition" element={<Exhibition /> } />
        <Route  path="/create-account" element={<Registration /> } />
        <Route  path="/register" element={<Register /> } /> 
        <Route  path="/forgot_password" element={<ForgotPassword /> } /> 
        <Route  path="/change_password/:token/:email" element={<ChangePassword /> } /> 
        <Route  path="/confirm_email" element={<ConfirmEmail /> } /> 
       {/*  <Route  path="/facilitator/form" element={<RequisitionForm /> } />  */}
        <Route  path="/logout" element={<Logout /> } />
       <Route  path="*" element={<Home />} /> 

        </Routes>
        </>
  )
}

export default UnProtectedView